var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper col-5 d-none p-0 d-lg-block"},[_c('div',{ref:"main-wrapper",staticClass:"slider-desktop-wrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }